import { ApiStatus, MessageType } from 'common/enums';

import { DataEditorState } from 'modules/data-editor/models/data-editor.model';
import { Mode } from 'modules/data-editor/enums/mode.enum';

const initialDataEditorState: DataEditorState = {
    isPreviewProgressVisible: false,
    mode: Mode.None,
    fieldErrors: [],
    previewDetailsAPIStatus: ApiStatus.NONE,
    previewDetails: undefined,
    editStatus: {},
    updatedData: {},
    editData: undefined,
    isEditModalVisible: false,
    messageModal: {
        isVisible: false,
        header: '',
        message: '',
        type: MessageType.Default
    },
    deleteData: {},
    searchList: { data: [] },
    errorCountFetchStatus: {},
    errorCount: -1,
    isAtleastOneErrorFixed: false,
    messageGuide: {
        isVisible: false,
        message: ''
    },
    messageBanner: {
        isVisible: false,
        message: ''
    },
    loadToMasterDataApiStatus: ApiStatus.NONE,
    clearPreview: {}
};

export default initialDataEditorState;
